import React from "react";
import styles from "../transfer.module.css";
// import { IoEyeOutline } from "react-icons/io5";
// import MarkEligibleCourseDetailsPopup from "../../../../views/pages/manage/edpOps/stockManagement/dlpStockIssuance/markEligible/MarkEligibleCourseDetailsPopup";
import {
  CourseDetailsPopupById,
  EyeIcon,
} from "views/pages/manage/unAssigned/studentCharges/common";

export const DetailsRow = ({ label, value, children }) => {
  return (
    <div className={styles["details-row-transfer"]}>
      <span className={styles["detail-cell-label-transfer"]}>{label} :</span>
      <span className={styles["detail-cell-value-transfer"]}>
        <span className="d-flex">
          {" "}
          {value || "-"} {children}
        </span>
      </span>
    </div>
  );
};

const StudentSummaryDetails = ({ studentDetails }) => {
  const {
    transferRequestNo = "",
    studentName = "",
    psid = "",
    applicationId = "",
    academicCareerValue = "",
    businessAreaDispVal = "",
    academicGroupDispValue = "",
    termDispVal,
    courseId = "",
    courseName = "",
    batch = "",
    term,
    businessArea,
  } = studentDetails || {};

  const summaryMap = [
    { label: "Transfer request no.", value: transferRequestNo },
    { label: "Name", value: studentName },
    { label: "PSID", value: psid },
    { label: "Application ID", value: applicationId },
    { label: "Career", value: academicCareerValue },
    { label: "Branch", value: businessAreaDispVal },
    { label: "Stream", value: academicGroupDispValue },
    { label: "Term", value: termDispVal },
    {
      label: "Course ID",
      value: courseId,
      renderExtra: (
        // <MarkEligibleCourseDetailsPopup
        //   Icon={IoEyeOutline}
        //   applicationData={{
        //     ...studentDetails,
        //     termId: term,
        //     buId: businessArea,
        //   }}
        //   isCollection={true}
        // />
        <CourseDetailsPopupById courseId={courseId} cta={<EyeIcon />} />
      ),
    },
  ];

  return (
    <div className={styles["student-details-grid-transfer"]}>
      {summaryMap.map((item) => (
        <DetailsRow key={item.label} label={item.label} value={item.value}>
          {item.renderExtra}
        </DetailsRow>
      ))}
    </div>
  );
};

export default StudentSummaryDetails;
